import styled from "styled-components";
import colors from "../../theme/color/ColorTheme";
import fontSize from "../../theme/fonts/FontTheme";

const Wrapper = styled.div`
  width: 500px;
  height: 220px;
  box-sizing: border-box;
  background-color: ${colors.backgroundSecondary};
  font-size: ${fontSize.s};
  padding: 25px 40px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  span {
    letter-spacing: 8%;
  }
  @media (max-width: 600px) {
    width: 350px;
  }
`;
function OrderInfoDialogBox() {
  return (
    <Wrapper>
      <span>
        Click Checkout to place your order. <br />
      </span>
      <span>
        Expected delivery is within 3–4 days after ordering.
        <br />
      </span>
      <span>
        You will be contacted by Wallet Service Members regarding your purchase.
      </span>
    </Wrapper>
  );
}

export default OrderInfoDialogBox;
